import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'environments/environment';

@Pipe({
  name: 'cmsMediaPrefix',
  standalone: true,
  pure: true
})
export class CmsMediaPrefixPipe implements PipeTransform {
  transform(value: string = ''): string {
    if (value && !value.startsWith('http')) {
      const url = `${environment.baseMedia}${value}`;
      return value.toLowerCase().includes('.mp4') ? `${url}#t=0.5` : url;
    }
    return value;
  }
}
